/**
 * 购物村
 */
export enum VILLAGE_TYPE {
    'ALL' = 0,
    'SUZHOU' = 1,
    'SHANGHAI' = 2,
}

export type VillageType = VILLAGE_TYPE.SUZHOU | VILLAGE_TYPE.SHANGHAI; // 1苏州 2上海

export const Village = {
    [VILLAGE_TYPE.SUZHOU]: 'SZ',
    [VILLAGE_TYPE.SHANGHAI]: 'SH',
};

export const ShoppingVillage = {
    [VILLAGE_TYPE.SUZHOU]: '苏州',
    [VILLAGE_TYPE.SHANGHAI]: '上海',
};

export const BicesterShoppingVillage = {
    [VILLAGE_TYPE.SUZHOU]: '比斯特苏州购物村',
    [VILLAGE_TYPE.SHANGHAI]: '比斯特上海购物村',
};

export const Bicester = {
    [VILLAGE_TYPE.ALL]: '比斯特苏州/上海',
    [VILLAGE_TYPE.SUZHOU]: '比斯特苏州',
    [VILLAGE_TYPE.SHANGHAI]: '比斯特上海',
};

/**
 * 角色权限type
 */
export enum ROLE_TYPE {
    /**
     * GE经理
     */
    'MANAGER' = 1,
    /**
     * GE领班
     */
    'GANGER' = 2,
    /**
     * GE迎宾大使
     */
    'AMBASSADOR' = 3,
    /**
     * GE兼职
     */
    'PT' = 4,
    /**
     * OPS安保
     */
    'OPS' = 5,
    /**
     * DRT导购大使
     */
    'DRT' = 6,
}

export type RoleType = ROLE_TYPE.MANAGER | ROLE_TYPE.GANGER | ROLE_TYPE.AMBASSADOR | ROLE_TYPE.PT | ROLE_TYPE.OPS | ROLE_TYPE.DRT;

/**
 * 角色权限
 */
export const Role = {
    [ROLE_TYPE.MANAGER]: 'GE经理',
    [ROLE_TYPE.GANGER]: 'GE领班',
    [ROLE_TYPE.AMBASSADOR]: 'GE迎宾大使',
    [ROLE_TYPE.PT]: 'GE兼职',
    [ROLE_TYPE.OPS]: 'OPS安保',
    [ROLE_TYPE.DRT]: '导购大使',
};

/**
 * 会员等级type
 */
export enum LEVEL_TYPE {
    /**
     * 非会员
     */
    'NOT' = -1,
    /**
     * 待激活
     */
    'NOTACTIVE' = 0,
    /**
     * 奕友
     */
    'YIYOU' = 1,
    /**
     * 奕享
     */
    'YIXIANG' = 2,
    /**
     * 奕尊
     */
    'YIZUN' = 3,
    /**
     * 奕尚
     */
    'YISHANG' = 4,
}

/**
 * 会员等级
 */
export const Level = {
    [LEVEL_TYPE.NOT]: '非会员',
    [LEVEL_TYPE.NOTACTIVE]: '待激活', // 待激活（前端当奕友处理）
    [LEVEL_TYPE.YIYOU]: '奕友',
    [LEVEL_TYPE.YIXIANG]: '奕享',
    [LEVEL_TYPE.YIZUN]: '奕尊',
    [LEVEL_TYPE.YISHANG]: '奕尚',
};

/**
 * 服务状态type
 */
export enum SERVICE_STATUS_TYPE {
    /**
     * 已取消
     */
    'CANCELED' = 0,
    /**
     * 已预约/待开始
     */
    'TO_START' = 1,
    /**
     * 进行中
     */
    'IN_PROGRESS' = 2,
    /**
     * 已完成
     */
    'FINISHED' = 3,
    /**
     * 已过期
     */
    'EXPIRED' = 4,
}

/**
 * 服务状态
 */
export const ServiceStatus = {
    [SERVICE_STATUS_TYPE.CANCELED]: '已取消',
    [SERVICE_STATUS_TYPE.TO_START]: '已预约/待开始',
    [SERVICE_STATUS_TYPE.IN_PROGRESS]: '进行中',
    [SERVICE_STATUS_TYPE.FINISHED]: '已完成',
    [SERVICE_STATUS_TYPE.EXPIRED]: '已过期',
};

/**
 * 服务项目类型type
 */
export enum SERVICE_TYPE {
    /**
     * 租赁服务
     */
    'LEASE' = 1,
    /**
     * 发票登记
     */
    'INVOICE' = 2,
    /**
     * 投诉反馈
     */
    'SUGGEST' = 3,
    /**
     * 礼品包装
     */
    'GIFTWRAP' = 4,
    /**
     * 商品快递
     */
    'EXPRESS' = 5,
    /**
     * 第三方积分登记
     */
    'THIRD' = 6,
    /**
     * 退税登记
     */
    'DRAWBACK' = 7,
    /**
     * 失物招领
     */
    'LOSE' = 8,
    /**
     * 其他服务
     */
    'OTHER' = 9,
    /**
     * 免提购物
     */
    'SHOPPING' = 10,
    /**
     * 代客泊车
     */
    'PARKING' = 11,
    /**
     * 导购大使
     */
    'SA' = 12,
    /**
     * 贵宾休息室
     */
    'LOUNGE' = 13,
    /**
     * 行李寄存
     */
    'LUGGAGE' = 14,
}

/**
 * 服务项目类型
 */
export const ServiceType = {
    [SERVICE_TYPE.LEASE]: '租赁服务',
    [SERVICE_TYPE.INVOICE]: '发票登记',
    [SERVICE_TYPE.SUGGEST]: '投诉反馈',
    [SERVICE_TYPE.GIFTWRAP]: '礼品包装',
    [SERVICE_TYPE.EXPRESS]: '商品快递',
    [SERVICE_TYPE.THIRD]: '第三方积分登记',
    [SERVICE_TYPE.DRAWBACK]: '退税登记',
    [SERVICE_TYPE.LOSE]: '失物招领',
    [SERVICE_TYPE.LUGGAGE]: '行李寄存',
    [SERVICE_TYPE.OTHER]: '其他服务',
};

/**
 * 页面类型
 */
export enum PAGE_TYPE {
    /**
     * 新建，没有默认值
     */
    'CREATE' = 'CREATE',
    /**
     * 详情，有默认值
     */
    'DETAIL' = 'DETAIL',
    /**
     * 其他页面
     */
    'OTHER' = 'OTHER',
}